// extracted by mini-css-extract-plugin
export default {"Blockies":"TeamBar_Blockies__eIvls","FlexDisplay":"TeamBar_FlexDisplay__AhDPl","TeamNameHover":"TeamBar_TeamNameHover__cBurx"};